import gate from '@/api/axios';

/**
 * Отправляет запрос на авторизацию
 * @async
 * @function authenticationLogin
 * @param {Object} payload
 * @returns {Promise}
 */
export const authenticationLogin = async (payload) => gate.post('/authentication/login', {
  deviceToken: 'token',
  ...payload,
});

/**
 * Изменить токен или удалить устройство
 * @async
 * @function setDevice
 * @param {Object} payload
 * @returns {Promise}
 */
export const setDevice = async (payload) => gate.post('/device/set', payload);

export default {
  authenticationLogin,
};
